class RingSizeFinder extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      buttonTable: ".generate-table-btn",
      containerTable: ".accordion__content",
      buttonCalculator: ".calculator__btn",
      input: ".ring-size-finder__input",
      resultUs: ".result_us",
      resultEu: ".result_eu",
      resultUk: ".result_uk",
      error: ".ring-size-finder__error",
    }

    this.classes = {
      errorVisible: "ring-size-finder__error--visible",
    }

    this.buttonTable = this.querySelector(this.selectors.buttonTable)
    this.containerTable = this.querySelector(this.selectors.containerTable)
    this.buttonCalculator = this.querySelector(this.selectors.buttonCalculator)
    this.input = this.querySelector(this.selectors.input)
    this.resultUs = this.querySelector(this.selectors.resultUs)
    this.resultEu = this.querySelector(this.selectors.resultEu)
    this.resultUk = this.querySelector(this.selectors.resultUk)

    this.generateTable()

    this.buttonCalculator.addEventListener("click", () => {
      let inputValue = this.input.value
      this.findSize(inputValue)
    })

    this.input.addEventListener("keyup", (e) => {
      if (e.key === "Enter") {
        this.findSize(e.currentTarget.value)
      }
    })

    this.ranges = [
      { range: "43.5-44.6", us: "3", eu: "44", uk: "F 1/2" },
      { range: "44.7-45.2", us: "3.5", eu: "45", uk: "G" },
      { range: "45.3-45.9", us: "3.5", eu: "46", uk: "G 1/2" },
      { range: "46-46.5", us: "4", eu: "46", uk: "H" },
      { range: "46.6-47.1", us: "4", eu: "47", uk: "H 1/2" },
      { range: "47.2-47.7", us: "4.5", eu: "48", uk: "I" },
      { range: "47.8-48.4", us: "4.5", eu: "48", uk: "I 1/2" },
      { range: "48.5-49", us: "5", eu: "49", uk: "J" },
      { range: "49.1-49.7", us: "5", eu: "49", uk: "J 1/2" },
      { range: "49.8-50.3", us: "5.5", eu: "50", uk: "K" },
      { range: "50.4-50.9", us: "5.5", eu: "51", uk: "K 1/2" },
      { range: "51-51.5", us: "6", eu: "51", uk: "L" },
      { range: "51.6-52.2", us: "6", eu: "52", uk: "L 1/2" },
      { range: "52.3-52.8", us: "6.5", eu: "53", uk: "M" },
      { range: "52.9-53.4", us: "6.5", eu: "53", uk: "M 1/2" },
      { range: "53.5-54.1", us: "7", eu: "54", uk: "N" },
      { range: "54.2-54.7", us: "7", eu: "54", uk: "N 1/2" },
      { range: "54.8-55.3", us: "7.5", eu: "55", uk: "O" },
      { range: "55.4-55.9", us: "7.5", eu: "56", uk: "O 1/2" },
      { range: "56-56.6", us: "8", eu: "56", uk: "P" },
      { range: "56.7-57.2", us: "8", eu: "57", uk: "P 1/2" },
      { range: "57.3-57.8", us: "8.5", eu: "58", uk: "Q" },
      { range: "57.9-58.8", us: "8.5", eu: "58", uk: "Q 1/2" },
      { range: "58.9-59.4", us: "9", eu: "59", uk: "R" },
      { range: "59.5-60", us: "9", eu: "60", uk: "R 1/2" },
      { range: "60.1-60.6", us: "9.5", eu: "60", uk: "S" },
      { range: "60.7-61.3", us: "9.5", eu: "61", uk: "S 1/2" },
      { range: "61.4-61.9", us: "10", eu: "62", uk: "T" },
      { range: "62-62.5", us: "10", eu: "62", uk: "T 1/2" },
      { range: "62.6-63.2", us: "10.5", eu: "63", uk: "U" },
      { range: "63.3-63.8", us: "10.5", eu: "63", uk: "U 1/2" },
      { range: "63.9-64.4", us: "11", eu: "64", uk: "V" },
      { range: "64.5-65", us: "11", eu: "65", uk: "V 1/2" },
      { range: "65.1-65.7", us: "11.5", eu: "65", uk: "W" },
      { range: "65.8-66.3", us: "11.5", eu: "66", uk: "W 1/2" },
      { range: "66.4-66.9", us: "12", eu: "67", uk: "X" },
      { range: "67-67.6", us: "12", eu: "67", uk: "X 1/2" },
      { range: "67.7-68.2", us: "12.5", eu: "68", uk: "Y" },
      { range: "68.3-68.8", us: "12.5", eu: "68", uk: "Z" },
      { range: "68.9-69.4", us: "13", eu: "69", uk: "Z 1/2" },
      { range: "69.5-70.5", us: "13", eu: "70", uk: "Z 1/2" },
    ]
  }

  sizes() {
    return [
      { mm: "44.3", us: "3", eu: "44", uk: "F 1/2" },
      { mm: "44.9", us: "-", eu: "45", uk: "G" },
      { mm: "45.6", us: "3.50", eu: "-", uk: "G 1/2" },
      { mm: "46.2", us: "-", eu: "46", uk: "H" },
      { mm: "46.8", us: "4", eu: "47", uk: "H 1/2" },
      { mm: "47.4", us: "-", eu: "-", uk: "I" },
      { mm: "48.1", us: "4.50", eu: "48", uk: "I 1/2" },
      { mm: "48.7", us: "-", eu: "-", uk: "J" },
      { mm: "49.3", us: "5", eu: "49", uk: "J 1/2" },
      { mm: "50.0", us: "-", eu: "50", uk: "K" },
      { mm: "50.6", us: "5.50", eu: "-", uk: "K 1/2" },
      { mm: "51.2", us: "-", eu: "51", uk: "L" },
      { mm: "51.8", us: "6", eu: "52", uk: "L 1/2" },
      { mm: "52.5", us: "-", eu: "-", uk: "M" },
      { mm: "53.1", us: "6.50", eu: "53", uk: "M 1/2" },
      { mm: "53.7", us: "-", eu: "-", uk: "N" },
      { mm: "54.4", us: "7", eu: "54", uk: "N 1/2" },
      { mm: "55.0", us: "-", eu: "55", uk: "O" },
      { mm: "55.6", us: "7.50", eu: "-", uk: "O 1/2" },
      { mm: "56.2", us: "-", eu: "56", uk: "P" },
      { mm: "56.9", us: "8", eu: "57", uk: "P 1/2" },
      { mm: "57.5", us: "-", eu: "-", uk: "Q" },
      { mm: "58.1", us: "8.50", eu: "58", uk: "Q 1/2" },
      { mm: "59.1", us: "-", eu: "59", uk: "R" },
      { mm: "59.7", us: "9", eu: "-", uk: "R 1/2" },
      { mm: "60.3", us: "-", eu: "60", uk: "S" },
      { mm: "60.9", us: "9.50", eu: "61", uk: "S 1/2" },
      { mm: "61.6", us: "-", eu: "-", uk: "T" },
      { mm: "62.2", us: "10", eu: "62", uk: "T 1/2" },
      { mm: "62.8", us: "-", eu: "-", uk: "U" },
      { mm: "63.5", us: "10.50", eu: "63", uk: "U 1/2" },
      { mm: "64.1", us: "-", eu: "64", uk: "V" },
      { mm: "64.7", us: "11", eu: "-", uk: "V 1/2" },
      { mm: "65.3", us: "-", eu: "65", uk: "W" },
      { mm: "66.0", us: "11.50", eu: "66", uk: "W 1/2" },
      { mm: "66.6", us: "-", eu: "-", uk: "X" },
      { mm: "67.2", us: "12", eu: "67", uk: "X 1/2" },
      { mm: "67.9", us: "-", eu: "-", uk: "Y" },
      { mm: "68.5", us: "12.50", eu: "68", uk: "Z" },
      { mm: "69.1", us: "-", eu: "69", uk: "Z 1/2" },
      { mm: "69.7", us: "13", eu: "70", uk: "-" },
    ]
  }

  generateTable() {
    const headersTable = [
      "Inside Circumference (mm)",
      "US/Canada",
      "EU",
      "UK/Australia",
    ]
    let sizes = this.sizes()

    let table = document.createElement("table")
    let headerRow = document.createElement("tr")

    headersTable.forEach((headerText) => {
      let header = document.createElement("th")
      let textNode = document.createTextNode(headerText)
      header.appendChild(textNode)
      headerRow.appendChild(header)
    })

    table.appendChild(headerRow)

    sizes.forEach((size) => {
      let row = document.createElement("tr")
      Object.values(size).forEach((text) => {
        let cell = document.createElement("td")
        let textNode = document.createTextNode(text)
        cell.appendChild(textNode)
        row.appendChild(cell)
      })
      table.appendChild(row)
    })

    this.containerTable.appendChild(table)
  }

  isInRange(value, range) {
    const min = parseFloat(range.split("-")[0])
    const max = parseFloat(range.split("-")[1])

    return value >= min && value <= max
  }

  findSize(inputValue) {
    const suggestedSizes = this.ranges.filter((row) =>
      this.isInRange(parseFloat(inputValue), row.range)
    )[0]

    this.querySelector(this.selectors.error).classList.remove(
      this.classes.errorVisible
    )
    this.resultUs.innerText = "-"
    this.resultEu.innerText = "-"
    this.resultUk.innerText = "-"

    if (suggestedSizes === undefined) {
      this.querySelector(this.selectors.error).classList.add(
        this.classes.errorVisible
      )
    } else {
      this.resultUs.innerText = suggestedSizes.us
      this.resultEu.innerText = suggestedSizes.eu
      this.resultUk.innerText = suggestedSizes.uk
    }
  }
}

customElements.define("ring-size-finder", RingSizeFinder)
